import React, { memo } from "react";

interface LoaderProps {
    height?: string;
    width?: string;
}

const Loader = memo(function Loader({ height = '100vh' }: LoaderProps) {
    return (
        <div className="w-100 loop-skeleton loop-background" style={{ minHeight: height, maxWidth: '1024px', margin: '0 auto' }}>
            <div className="container p-3 p-md-4" style={{ maxWidth: '100%' }}>

                {/* Form Fields Section */}
                <div className="row g-3 mb-4">
                    {Array.from({ length: 5 }).map((_, index) => (
                        <div key={index} className="col-12">
                            <div className="p-2">
                                <div className="skeleton-box rounded mb-2" style={{ height: '40px', width: '100%' }}>
                                    &nbsp;
                                </div>
                                {index % 2 === 0 && (
                                    <div className="skeleton-box rounded" style={{ height: '14px', width: '150px' }}>
                                        &nbsp;
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
});

export default Loader;
